import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const TableNotRelated = ({ store }) => {
    const changeValue = (event) => {
        const { target: { checked } } = event;
        store.queryNotRelated = checked ? 'artwork' : null;
    };
    return (
        <div>
            <div className="form-check mb-2 mr-sm-2 mb-sm-0">
                <label className="form-check-label" htmlFor="defaultCheck1">
                    <input className="form-check-input" type="checkbox" value="" id="defaultCheck1" onChange={changeValue} />
                    Without related Artwork
                </label>
            </div>
        </div>);
};


TableNotRelated.propTypes = {
    store: PropTypes.object.isRequired,
};

export default (observer(TableNotRelated));
